/* eslint-disable import/order -- Sentry instrument must load first */
import './instrument';
import './index.css';
/* eslint-enable import/order */

import React from 'react';

import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import store from './store/store';

const container = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(container);

root.render(
   <Sentry.ErrorBoundary fallback={<p>An error has occurred. Please refresh the page.</p>}>
      <Provider store={store}>
         <BrowserRouter basename='/'>
            <App />
         </BrowserRouter>
      </Provider>
   </Sentry.ErrorBoundary>,
);
